import React, { useState, useEffect, useRef } from 'react';

import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from '../mensajes';
import axios from 'axios';
import { Dimmer } from '../spinner';

import moment from 'moment';
import { formatMoneda } from '../../util/varios';
import { CreditoAdicional } from './modalCreditoAdicional';


const TablaCreditoAdicional = (props) => {

  var op = require('../../../src/modulos/datos')
  let token = localStorage.getItem('jwtToken');
  const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
  const anioefiscal = JSON.parse(localStorage.getItem('efiscalanio'));
  let municipios = [];

  const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CÓDIGO', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'MONTO', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FECHA', textAlign: 'center' },
    { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'OBSERVACIÓN', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]


  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [creditoadi, setCreditoAdi] = useState();
  const [catpro, setCatpro] = useState();
  const [creditoDet, setCreditoDet] = useState();
  const txtBuscador = useRef()
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);

  const handleSearch = e => {
    let target = e.target;
    setFilterFn({
      fn: items => {
        if (target.value === "")
          return items;
        else
          return items.filter(x => {

            if (x.idcreditoadiingreso.includes(target.value)
              || formatMoneda(x.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2).toLowerCase().includes(target.value.toLowerCase())
              || moment.utc(x.fechaapro).format('YYYY-MM-DD').toLowerCase().includes(target.value.toLowerCase())
              || x.observaciones.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      }
    })

  }

  const seleccionarRegistros = () => {

    setActivate(true);

    let campos = "*"
    let nomtab = "creditoadiingreso";
    let nomid = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}`
    console.log(endpoint);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.length > 0) {
          setRecords(response.data);
        } else {
          setRecords([]);
        }
        setActivate(false);
      }

    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  }

  const SeleccionarCreditoAdicional = (id) => {

    setActivate(true);
    let endpoint = `${op.conexion}/api/presupuesto/seleccionarcreditoadi?idcredito=${id}&idefi=${idefiscal}&anioefi=${anioefiscal}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {
        setActivate(false);
        setCreditoAdi(response.data[0]);
        setCreditoDet(response.data);
        setMostrar2(true);
        /*if (response.data.idcuenta > 0) {
          setCreditoAdi(response.data);
          seleccionarCatProgramatica(response.data);
        } else {
          setCreditoAdi()
          seleccionarCatProgramatica(response.data);
        }*/

      }

    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  }

  const seleccionarCatProgramatica = (data) => {

    setActivate(true);

    let campos = "*"
    let nomtab = "categoriaprogramatica";
    let nomid = "idcategoriaprogramatica";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idcategoriaprogramatica}&nomtab=${nomtab}&nomid=${nomid}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.idcategoriaprogramatica > 0) {
          setCatpro(response.data);
          seleccionarClasPresupuestario(data);
        } else {
          setCatpro()
          seleccionarClasPresupuestario(data);
        }
        setActivate(false);
      }

    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  }

  const seleccionarClasPresupuestario = (data) => {

    setActivate(true);

    let campos = "*"
    let nomtab = "puc";
    let nomid = "idpuc";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idpuc}&nomtab=${nomtab}&nomid=${nomid}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.idpuc > 0) {
          setCreditoDet(response.data);
          setMostrar2(true);
        } else {
          setCreditoDet()
          setMostrar2(true);
        }
        setActivate(false);
      }

    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  }


  const handleCloseSi = () => {

    setActivate(false);

  };

  const gestionarCreditoAdicional = (op, id) => (e) => {
    setOperacion(op);
    if (op === 4 || op === 2 || op === 3) {
      SeleccionarCreditoAdicional(id);
    } else if (op === 1) {
      setMostrar2(true)
    }

  }


  useEffect(() => {
    seleccionarRegistros();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  }

  const cerrar = () => {
    props.menu()
  }
  return (
    <section className='modal-azulGradiant mx-auto col-9'>

      <header className='header-azulGradiant'>
        <h3 >
          Credito Adicional
        </h3>
        <a type='button' onClick={cerrar}>
          salir<i className="fas fa-times"></i>
        </a>
      </header>
      <div className="form-azulGradiant px-2">
        <input type="text" className="search-input col-3 form-control text-uppercase form-control-sm rounded-pill" ref={txtBuscador} onChange={handleSearch} placeholder="Buscar" />
        <button onClick={gestionarCreditoAdicional(1, '')} style={{ marginBottom: "5px" }} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>

      </div>
      <div className="col-md-12 m-0" >
            <TblContainer>
              <TblHead />
              <tbody>
                {
                  records && recordsAfterPagingAndSorting().map((item, index) => (
                    <tr key={index + item.idcuenta} style={{ padding: "0" }}>
                      <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '40px' }}>{item.idcreditoadiingreso}</td>
                      <td className='align-middle' style={{ textAlign: "right", alignItems: 'center', width: '100px' }}>{formatMoneda(item.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                      <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>{moment.utc(item.fechaapro).format('YYYY-MM-DD')}</td>
                      <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '250px' }}>{item.observaciones}</td>
                      <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>
                        <button onClick={gestionarCreditoAdicional(4, item.idcreditoadiingreso)} className="btn btn-sm mx-1 btn-info rounded-circle" ><i className="fas fa-eye"></i> </button>
                        <button onClick={gestionarCreditoAdicional(2, item.idcreditoadiingreso)} className="btn btn-sm mx-1 btn-warning rounded-circle"><i className="fa fa-edit"></i> </button>
                        <button onClick={gestionarCreditoAdicional(3, item.idcreditoadiingreso)} className="btn btn-sm mx-1 btn-danger rounded-circle"><i className="fa fa-trash"></i> </button>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </TblContainer>
            <TblPagination />
          </div>
      <CreditoAdicional
        show={mostrar2}
        operacion={operacion}
        creditoadi={creditoadi}
        creditodet={creditoDet}
        onHideCancelar={handleCancelar}
        onHideRenderizar={seleccionarRegistros}
      />


      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

      <Dimmer active={activate} inverted>
      </Dimmer>

    </section>
  );
}
export default TablaCreditoAdicional;